const searchStrip = {
  hotels: "Alberghi", // translated
  city: "Città", // translated
  checkIn: "Registrare", // translated
  checkOut: "Guardare", // translated
  date: "Data", // translated
  persons: "Persone", // translated
  adults: "Adulti", // translated
  rooms: "Camere", // translated
  editSearch: "Modifica ricerca", // translated
  newSearch: "Nuova ricerca", // translated
  listView: "Visualizzazione elenco", // translated
  mapView: "Vista mappa", // translated
};


export default searchStrip;
